<template>
<offers
    :partId="partId"
    :crfqLineId="reqLineId"
    :gridId="gridId"
    clearListOnPart
/>
</template>

<script>
/*import { mapGetters } from 'vuex';*/

import Offers from '@/shared/components/Offers';
import { GRID_ID } from '@/shared/constants';

export default {
  props: {
    isCrfq: {
      type: Boolean,
      default: false
    },
    reqLineId: {
      type: [Number, String],
      default: 0
    },
    partId: {
      type: [Number, String],
      default: 0
    }
  },

  components: {
    Offers,
  },
  data: () => ({
    gridId: GRID_ID.REQUIREMENT_OFFERS,
  }),
  /*computed: {
    ...mapGetters('requirements', [
      'selectedRequirement',
    ]),
    ...mapGetters('requirementAdd', [
      'currentPart',
    ]),
  },*/
};
</script>